module.exports = __webpack_public_path__ + "static/media/UserLogo.6c7ee63a.svg";